module.exports = __webpack_public_path__ + "assets/img/thumb-ARUMALABS-1-Video.d9b3d6ce.webp";